module.exports = __webpack_public_path__ + "img/187w.4606ea3.jpg";